export const MaximumImageFileSizeMB = 50;
export const MaximumVideoFileSizeMB = 1e4;

// Refer to https://docs.microsoft.com/en-us/azure/media-services/latest/encode-media-encoder-standard-formats-reference
// Plus some additional video formats supported by Xandr confirmed by Weiyuan to work with AMS
export const allowedVideoFileExtensions = [
  '.flv',
  '.mxf',
  '.gxf',
  '.ts',
  '.ps',
  '.3gp',
  '.3gpp',
  '.mpg',
  '.wmv',
  '.asf',
  '.avi',
  '.mp4',
  '.m4a',
  '.m4v',
  '.isma',
  '.ismv',
  '.dvr-ms',
  '.mkv',
  '.wav',
  '.mov',
  '.vob',
  '.ogv',
  '.qt',
  '.mpv',
  '.m2v',
  '.3g2',
  '.swf',
  '.mpeg',
  '.mpe',
];
